import {
  getBlockStateOptions,
  getConnectionType,
  getPlacementType
} from "../core/blockRegistry.ts";
import { useEditorStore } from "../store/editorStore";

export function BlockStateEditor() {
  const blockId = useEditorStore((state) => state.activeBlockId);
  const blockState = useEditorStore(
    (state) => state.activeBlockState
  );
  const setValue = useEditorStore(
    (state) => state.setActiveBlockStateValue
  );

  const options = getBlockStateOptions(blockId) as Record<
    string,
    string[]
  >;
  const connectionType = getConnectionType(blockId);
  const placementType = getPlacementType(blockId);
  const autoManaged = new Set<string>();

  if (connectionType) {
    ["north", "east", "south", "west", "up"].forEach((key) =>
      autoManaged.add(key)
    );
  }
  if (
    placementType === "door" ||
    placementType === "double_plant"
  ) {
    autoManaged.add("half");
  }
  if (placementType === "bed") {
    autoManaged.add("part");
    autoManaged.add("occupied");
  }

  const entries = Object.entries(options).filter(
    ([key]) => !autoManaged.has(key)
  );

  if (entries.length === 0) {
    return (
      <div className="block-state-editor">
        <div className="block-state-empty">
          {connectionType
            ? "Connections are calculated automatically from neighboring blocks."
            : placementType
              ? "Paired block states are calculated automatically during placement."
              : "This block has no editable placement state."}
        </div>
      </div>
    );
  }

  return (
    <div className="block-state-editor">
      <div className="block-state-grid">
        {entries.map(([key, values]) => (
          <label className="block-state-field" key={key}>
            <span>{key}</span>
            <select
              value={blockState[key] ?? values[0]}
              onChange={(event) => setValue(key, event.target.value)}
            >
              {values.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>

      {placementType && (
        <div className="block-state-note">
          {placementType === "bed"
            ? "Bed head/foot blocks are placed and removed together automatically."
            : placementType === "double_plant"
              ? "Upper/lower plant halves are managed automatically."
              : "Door upper/lower halves are placed and removed together automatically."}
        </div>
      )}
    </div>
  );
}
